export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



// WEBPACK FOOTER //
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/d3-force/src/jiggle.js